<template xmlns:v="http://www.w3.org/1999/html">
    <div class="main">
        <div ref="getQueryHeight">
            <!--查询按钮-->
            <div class="queryButton">
                <a-col>
                    <img class="funcButton" src="../../assets/img/search.png" width="22" height="22" @click="query" >
                    <img class="funcButton" src="../../assets/img/refresh2.png" width="22" height="22" @click="reset">
                </a-col>
            </div>
            <div>
                <a-form :form="formQuery">
                    <div class="queryParam">
                        <a-form-item  class="genericFrom" label="DoNo:">
                            <a-input ref="doNo" size="small"  v-decorator="['doId']" @pressEnter="query"/>
                        </a-form-item>
                    </div>
                    <div class="queryParam">
                        <a-form-item class="genericFrom"  label="Ref:">
                            <a-input ref="ref"  size="small"   v-decorator="['custRef1']" @pressEnter="query" />
                        </a-form-item>
                    </div>
                    <div class="queryParam">
                        <a-form-item class="genericFrom" label="Exp Delivery From:">
                            <a-date-picker
                                    ref="expDeliveryFrom"
                                    size="small"
                                    placeholder='Exp Delivery From'
                                    style="width: 100%"
                                    allowClear
                                    format="YYYY-MM-DD"
                                    v-decorator="['expDeliveryDateFrom',]">
                            </a-date-picker>
                        </a-form-item>
                    </div>
                    <div class="queryParam">
                        <a-form-item class="genericFrom" label="Exp Delivery To:">
                            <a-date-picker
                                    ref="expDeliveryTo"
                                    size="small"
                                    placeholder='Exp Delivery To'
                                    style="width: 100%"
                                    allowClear
                                    format="YYYY-MM-DD"
                                    v-decorator="['expDeliveryDateTo',]">
                            </a-date-picker>
                        </a-form-item>
                    </div>
                </a-form>
            </div>
          <div class="pagination">
            <a-row style="border: 1px solid gray;padding:4px">
                <a-row type="flex" justify="space-between">
                    <a-col>
                        <a-row type="flex" justify="start" align="middle">
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>{{ $t('roleGe.Add') }}</span>
                                </template>
                                <img class="sbxs mllr4" src="../../assets/img/ss-add.png"  width="22" height="22" @click="addOrders">
                            </a-tooltip>
                            <a-popconfirm
                                    :title="$t('pubGicSet.AreyoudeleTask')"
                                    :okText="$t('pubGicSet.Yes')"
                                    :cancelText="$t('pubGicSet.No')"
                                    @confirm="delOrders"
                            >
                                <a-tooltip placement="topLeft">
                                    <template slot="title">
                                        <span>{{ $t('roleGe.Delete') }}</span>
                                    </template>
                                    <img class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                                </a-tooltip>
                            </a-popconfirm>
                            <a-tooltip placement="topLeft">
                                <template slot="title">
                                    <span>Refresh</span>
                                </template>
                                <img class="sbxs mllr4" style='margin-top: 2px' src="../../assets/img/ss-refresh.png" width="22" height="20" @click="init">
                            </a-tooltip>
                        </a-row>
                    </a-col>
                    <a-col>
                        <a-pagination
                                :pageSizeOptions="orders.pageSizeOptions"
                                :showTotal="total => `${$t('generic.totalOf')} ${orders.pagingTotal} ${$t('generic.Records')}`"
                                size="small"
                                :total="orders.pagingTotal"
                                v-model="orders.currentVal"
                                :pageSize.sync="orders.pagingSize"
                                @change="tableChangePage"
                                @showSizeChange="onShowSizeChange"
                                showSizeChanger
                        />
                    </a-col>
                </a-row>
                <a-row class="mt4">
                    <vxe-table
                            stripe
                            resizable
                            border
                            show-header-overflow
                            show-overflow
                            highlight-hover-row
                            ref="ordersTableRef"
                            class="sortable-row-demo"
                            @cell-dblclick="dbClickEdit"
                            size="mini"
                            :height="1000"
                            :data="tableData">
                        <template v-slot:empty>
                            <span style="font-size: 12px; color: red;"></span>
                        </template>
                        <vxe-table-column field="doId" title="Do No." width="150" sortable></vxe-table-column>
                        <vxe-table-column field="orderType" title="Type" width="150" sortable>
                            <template v-slot="{ row }">
                                {{ row.orderType | filterOrdetType}}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="status" width="80" title="Status">
                            <template v-slot="{ row }">
                                {{ row.status | filterSatus}}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="custRef1" title="Ref" width="120" sortable></vxe-table-column>
                        <vxe-table-column field="expDeliveryDate" :formatter="formatTime" width="120" title="Expect Delivery" sortable></vxe-table-column>

                        <!--<vxe-table-column field="address1" title="Address"></vxe-table-column>-->
                        <vxe-table-column field="mapPickupAddress1" title="Map Pickup Address" :visible="false"></vxe-table-column>
                       <vxe-table-column field="mapDeliveryAddress1" title="Map Delivery Address" :visible="false"></vxe-table-column>

                        <vxe-table-column  title="Delivery Address">
                            <template v-slot="{ row }">
                                <span> {{ row.orderType === 'P' ? "": row.deliveryAddress1}}</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column  title="Pickup Address">
                            <template v-slot="{ row }">
                                <span> {{ row.orderType === 'D' ? "": row. pickupAddress1}}</span>
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </a-row>
            </a-row>
          </div>

            <a-modal v-model="visible" title="Orders" width="70%" :maskClosable="false">
                <template slot="footer">
                    <a-button type="primary" size="small"  @click="saveOrders">{{ $t('publicLang.Save') }}</a-button>
                </template>
                <a-row style="height: 70vh;overflow-y:auto;overflow-x:hidden">
                    <a-form :form="form" >
                        <a-collapse v-model="activeKey" :bordered="false">
                        <a-collapse-panel key="1" header="main">
                            <a-row :gutter="24">
                                <a-col :span="12">
                                    <a-form-item label="Order Type" class="genericFrom">
                                        <a-select
                                            style="width: 100%"
                                            size="small"
                                            v-bind:disabled="orderFormDisabled"
                                            @change="orderTypeChange"
                                            v-decorator="['orderType',
                                             {
                                                  initialValue: orderFromVal.orderType,
                                                   rules: [{ required: true, message: 'Order Type is Required' }]
                                             }
                                         ]">
                                            <a-select-option :value="item.CODE" v-for="item in selectData.tmsOrderTypes">{{item.CODE_DESC}}</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Order Date" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="[
                                                'orderDate',
                                                {
                                                    initialValue:orderFromVal.orderDate ?  moment(orderFromVal.orderDate, 'YYYY-MM-DD HH:mm:ss') : null,
                                                    rules: [{ required: true, message: 'Order Date is Required' }]
                                                }]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Status" class="genericFrom">
                                        <a-select
                                                style="width: 100%"
                                                size="small"
                                                disabled
                                                v-decorator="['status',
                                             {
                                                  initialValue: orderFromVal.status == null ? '00' : orderFromVal.status
                                             }
                                         ]">
                                            <a-select-option :value="item.CODE" v-for="item in localData.TMS_ORDER_STATUS">{{item.CODE_DESC}}</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Ref1" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['custRef1',
                                             {
                                                  initialValue: orderFromVal.custRef1,
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Ref2" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['custRef2',
                                             {
                                                  initialValue: orderFromVal.custRef2,
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Ref3" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['custRef3',
                                             {
                                                  initialValue: orderFromVal.custRef3,
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Expect Delivery" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['expDeliveryDate', { initialValue:orderFromVal.expDeliveryDate ?  moment(orderFromVal.expDeliveryDate, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Actual Delivery" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['actualDeliveryDate', { initialValue:orderFromVal.actualDeliveryDate ?  moment(orderFromVal.actualDeliveryDate, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>

                              <!--  <a-col :span="12">
                                    <a-form-item label="Expect Start Time" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['expStartTime', { initialValue:orderFromVal.expStartTime ?  moment(orderFromVal.expStartTime, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Expect End Time" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['expEndTime', { initialValue:orderFromVal.expEndTime ?  moment(orderFromVal.expEndTime, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>-->
                                <a-col :span="12">
                                    <a-form-item label="Expect Time Window" class="genericFrom">
                                        <a-select
                                                style="width: 100%"
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['expDeliveryWindow',
                                             {
                                                  initialValue: orderFromVal.expDeliveryWindow
                                             }
                                         ]">
                                            <a-select-option :value="item.CODE" v-for="item in localData.TMS_TIME_WINDOW">{{item.CODE_DESC}}</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>



                            </a-row>
                        </a-collapse-panel>
                        <a-collapse-panel key="2" header="Delivery">
                            <a-row :gutter="24">
                                <a-col :span="12">
                                    <a-form-item label="Delivery Name" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['deliveryName',
                                                 {
                                                      initialValue: orderFromVal.deliveryName,
                                                      // rules: [{ required: targetOrderTypeDelType, message: 'Delivery Name is Required' }]
                                                 }
                                             ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Contact" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['deliveryContact',
                                                 {
                                                      initialValue: orderFromVal.deliveryContact,
                                                 }
                                             ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Phone" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['deliveryPhone',
                                             {
                                                  initialValue: orderFromVal.deliveryPhone,
                                                  // rules: [{ required: targetOrderTypeDelType, message: 'Phone is Required' }]
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Email" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['deliveryEmail',
                                             {
                                                  initialValue: orderFromVal.deliveryEmail,
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Address1" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['deliveryAddress1',
                                             {
                                                  initialValue: orderFromVal.deliveryAddress1,
                                                   rules: [{ required: targetOrderTypeDelType, message: 'Address1 is Required' }]
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Address2" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['deliveryAddress2',
                                             {
                                                  initialValue: orderFromVal.deliveryAddress2,
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Address3" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['deliveryAddress3',
                                             {
                                                  initialValue: orderFromVal.deliveryAddress3,
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Address4" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['deliveryAddress4',
                                             {
                                                  initialValue: orderFromVal.deliveryAddress4,
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-collapse-panel>
                        <a-collapse-panel key="3" header="Pickup">
                            <a-row :gutter="24">
                                <a-col :span="12">
                                    <a-form-item label="Pickup Name" class="genericFrom">
                                        <a-input
                                            size="small"
                                            v-bind:disabled="orderFormDisabled"
                                            v-decorator="['pickupName',
                                             {
                                                  initialValue: orderFromVal.pickupName,
                                                  // rules: [{ required: targetOrderTypePickType, message: 'Pickup Name is Required' }]
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Contact" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['pickupContact',
                                         {
                                              initialValue: orderFromVal.pickupContact,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Phone" class="genericFrom">
                                        <a-input
                                            size="small"
                                            v-bind:disabled="orderFormDisabled"
                                            v-decorator="['pickupPhone',
                                             {
                                                  initialValue: orderFromVal.pickupPhone,
                                                  // rules: [{ required: targetOrderTypePickType, message: 'Phone is Required'}]
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Email" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['pickupEmail',
                                         {
                                              initialValue: orderFromVal.pickupEmail,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Address1" class="genericFrom">
                                        <a-input
                                            size="small"
                                            v-bind:disabled="orderFormDisabled"
                                            v-decorator="['pickupAddress1',
                                             {
                                                  initialValue: orderFromVal.pickupAddress1,
                                                   rules: [{ required: targetOrderTypePickType, message: 'Address1 is Required' }]
                                             }
                                         ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Address2" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['pickupAddress2',
                                         {
                                              initialValue: orderFromVal.pickupAddress2,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Address3" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['pickupAddress3',
                                         {
                                              initialValue: orderFromVal.pickupAddress3,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Address4" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['pickupAddress4',
                                         {
                                              initialValue: orderFromVal.pickupAddress4,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-collapse-panel>

                        <a-collapse-panel key="4" header="Signature and Photo">
                            <a-row :gutter="24">
                                <p v-for="(imageUrl,i) in imageUrlList">
                                    <a-col :span="2">
                                    <img :src="imageUrl" width="80" height="80" style="margin: 0 10px 10px 10px;border-radius: 5px;" @click="previewImage(imageUrl)"/>
                                    </a-col>
                                </p>

                            </a-row>
                        </a-collapse-panel>
                        <a-collapse-panel key="5" header="Additional">
                            <a-row :gutter="24">
                                <a-col :span="12">
                                    <a-form-item label="Total Weight" class="genericFrom">
                                        <a-input-number
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                v-decorator="['weight',
                                         {
                                              initialValue: orderFromVal.weight,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Weight Uom" class="genericFrom">
                                        <a-select
                                                style="width: 100%"
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['weightUom',
                                             {
                                                  initialValue: orderFromVal.weightUom,
                                             }
                                         ]"
                                        >
                                            <a-select-option :value="item.CODE" v-for="item in selectData.weightUom">{{item.CODE_DESC}}</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="No.of Pallet" class="genericFrom">
                                        <a-input-number
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                v-decorator="['noOfPallet',
                                         {
                                              initialValue: orderFromVal.noOfPallet,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Total Volume" class="genericFrom">
                                        <a-input-number
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                v-decorator="['volume',
                                         {
                                              initialValue: orderFromVal.volume,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Dimension Uom" class="genericFrom">
                                        <a-select
                                                style="width: 100%"
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['dimensionUom',
                                             {
                                                  initialValue: orderFromVal.dimensionUom,
                                             }
                                         ]"
                                        >
                                            <a-select-option :value="item.CODE" v-for="item in selectData.dimensionUom">{{item.CODE_DESC}}</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="No.of Carton" class="genericFrom">
                                        <a-input-number
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                v-decorator="['noOfCarton',
                                         {
                                              initialValue: orderFromVal.noOfCarton,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="COD Amount" class="genericFrom">
                                        <a-input-number
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                v-decorator="['codAmount',
                                         {
                                              initialValue: orderFromVal.codAmount,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="COD Currency" class="genericFrom">
                                        <a-select
                                                style="width: 100%"
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['codCurrency',
                                             {
                                                  initialValue: orderFromVal.codCurrency,
                                             }
                                         ]"
                                        >
                                            <a-select-option :value="item.CODE" v-for="item in selectData.tmsCodCurrencys">{{item.CODE_DESC}}</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Priority" class="genericFrom">
                                        <a-select
                                                style="width: 100%"
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['priority',
                                             {
                                                  initialValue: orderFromVal.priority,
                                             }
                                         ]"
                                        >
                                            <a-select-option :value="item.CODE" v-for="item in selectData.priority">{{item.CODE_DESC}}</a-select-option>
                                        </a-select>
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Special Instruction" class="genericFrom">
                                        <a-input
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                v-decorator="['specialInstruction',
                                         {
                                              initialValue: orderFromVal.specialInstruction,
                                         }
                                     ]"
                                        />
                                    </a-form-item>
                                </a-col> <a-col :span="12">
                                <a-form-item label="Remark" class="genericFrom">
                                    <a-input
                                            size="small"
                                            v-bind:disabled="orderFormDisabled"
                                            v-decorator="['remark',
                                         {
                                              initialValue: orderFromVal.remark,
                                         }
                                     ]"
                                    />
                                </a-form-item>
                            </a-col>
                            </a-row>
                        </a-collapse-panel>
                        <a-collapse-panel key="6" header="EDI">
                            <a-row :gutter="24">
                                <a-col :span="12">
                                    <a-form-item label="Send Time1" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['ediSendtime1', { initialValue:orderFromVal.ediSendtime1 ?  moment(orderFromVal.ediSendtime1, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Send Time2" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['ediSendtime2', { initialValue:orderFromVal.ediSendtime2 ?  moment(orderFromVal.ediSendtime2, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Send Time3" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['ediSendtime3', { initialValue:orderFromVal.ediSendtime3 ?  moment(orderFromVal.ediSendtime3, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Send Time4" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['ediSendtime4', { initialValue:orderFromVal.ediSendtime4 ?  moment(orderFromVal.ediSendtime4, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-item label="Send Time5" class="genericFrom">
                                        <a-date-picker
                                                size="small"
                                                v-bind:disabled="orderFormDisabled"
                                                style="width: 100%;"
                                                format="YYYY-MM-DD HH:mm:ss"
                                                :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                                v-decorator="['ediSendtime5', { initialValue:orderFromVal.ediSendtime5 ?  moment(orderFromVal.ediSendtime5, 'YYYY-MM-DD HH:mm:ss') : null }]"
                                        />
                                    </a-form-item>
                                </a-col>
                            </a-row>
                        </a-collapse-panel>
                        </a-collapse>
                    </a-form>
                </a-row>
            </a-modal>

            <a-modal
                    :visible="uploadVisible"
                    width="60%"
                    cancelText="-"
                    okText="-"
                    @cancel="cancelModal"
            >

               <template slot="footer">
                    <a-button type="primary"  @click="fileUpload" >{{ $t('publicLang.Save') }}</a-button>
                </template>
                    <a-row>
                        <label>{{$t('generic.TemplateName')}}: </label>
                    </a-row>
                    <a-row class='mt4' type="flex" justify="start" >
                        <a-col>
                            <span class="file">{{ $t('reportSetting.Upload')}}
                              <!--<input id="uploadFile" accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ref="importExcelRef"  v-on:change="fileChange($event)" type="file" multiple="multiple" >
                                -->
                                <input type="file" accept=".xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                        @change="fileSelected" ref="importExcelRef" multiple="multiple">

                            </span>
                        </a-col>
                        <a-col class="ml4">{{updataExcelName}}</a-col>
                    </a-row>

            </a-modal>

            <a-modal
                    :visible="isShowImage"
                    title="Preivew Image"
                    width="50%"
                    @cancel="hideImage"
                    align="center"
                    >
                <template slot="footer">
                    <a-button type="primary" size="small"  @click="hideImage">{{ $t('publicLang.Cancel')}}</a-button>
                </template>
                <img :src="imgUrl" width="380" style="margin: 0 10px 10px 10px;border-radius: 5px;"/>
            </a-modal>

        </div>
    </div>

</template>
<script>
    import Sortable from "sortablejs";
    import ajax from '../../api/ajax'
    import api from '../../api/url'
    import moment from 'moment'
    import XEUtils from "xe-utils";
    export default{
        props:{
           ordersHeight: {
                type: Number,
                default: ()=>{
                    return 100
                }
            },
            routeNo:{
                type: String
            },
            waypointNo:{
               type:String
            },
            wayUid:{
                type:String
            }
        },
        data(){
            return{
                tableData: [],
                oldTable: [],
                targetOrderTypeDelType: false,
                targetOrderTypePickType: false,
                visible:false,
                form: this.$form.createForm(this),
                orderFormDisabled:false,
                orders: {
                    pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
                    pagingTotal:0,
                    currentVal: 1,
                    pagingSize: 20
                },
                orderFromVal: {},// 编辑当前显示的内容
                selectData:{},
                activeKey:['1'],
                uploadVisible:false,
                updataExcelName: '', // 上传成功文件名
                files: [],
                localData: {},
                isShowImage:false,
                imgUrl:'',
                imageUrlList:[],
                formQuery: this.$form.createForm(this, {}),
            }
        },
        created () {
            this.rowDrop()
            this.init()
            this.localData = JSON.parse(sessionStorage.getItem('localData'))
        },
        beforeDestroy () {
            if (this.sortable) {
                this.sortable.destroy()
            }
        },
        filters: {
            filterSatus(val) {
                let data = JSON.parse(sessionStorage.getItem('localData'))
                data = data.TMS_ORDER_STATUS
                for(let i in data){
                    if(val == data[i].CODE){
                        return data[i].CODE_DESC
                    }
                }
            },
            filterOrdetType(val) {
                let data = JSON.parse(sessionStorage.getItem('localData'))
                data = data.TMS_ORDER_TYPE
                for(let i in data){
                    if(val == data[i].CODE){
                        return data[i].CODE_DESC
                    }
                }
            }
        },
        methods: {
            formatTime ({cellValue}) {
                return XEUtils.toDateString(cellValue, 'yyyy-MM-dd')
            },
            orderTypeChange(v){
                if(v == 'D' || v == 'DP'){
                    this.activeKey = ['1','2','5','6']
                    this.targetOrderTypeDelType = true
                    if(v == 'DP'){
                        this.targetOrderTypePickType = true
                        this.activeKey = ['1','2','3','5','6']
                    }else{
                        this.targetOrderTypePickType = false
                    }
                }else if(v == 'P' || v == 'PD'){
                    this.activeKey = ['1','3','5','6']
                    this.targetOrderTypePickType = true
                    if(v == 'PD'){
                        this.targetOrderTypeDelType = true
                        this.activeKey = ['1','2','3','5','6']
                    }else{
                        this.targetOrderTypeDelType = false
                    }
                }
            },
            delEdit(id){
                this.fromSelectData()
                ajax.get(api.TMSGETTMSDOHEADERBYID,{doHeaderUid: id}).then(res=>{
                    this.visible = true
                    this.form.resetFields();
                    this.orderFromVal = res.data

                    console.log("status:"+this.orderFromVal.status)
                    if(this.orderFromVal.status!='00'){
                        this.orderFormDisabled = true;
                    }else{
                        this.orderFormDisabled = false;
                    }
                })
            },
            moment,
            //      分页
            onShowSizeChange(current, pageSize) {
                this.orders.currentVal = current;
                this.orders.pagingSize = pageSize;
                this.init()
            },
            tableChangePage(current) {
                this.orders.currentVal = current;
                this.init()
            },
//            删除orders
            delOrders(){
                let len = this.$refs.ordersTableRef.getCheckboxRecords()
                if(len.length > 0){
                    let arr = []
                    let flag = true
                    for(let i in len){
                        if(len[i].status == '52' || len[i].status == '53' || len[i].status == '98' || len[i].status == '99'){
                            let str = len[i].doId + ' status not allow delete'
                            this.$customMessage.warning(str);
                            flag = false
                        }
                        arr.push(len[i].uid)
                    }
                    if(!flag){return}
                    let params = {
                        doHeaderUids:arr.toString()
                    }
                    ajax.post(api.TMSDELETETMSDOHEADER,params).then(res=>{
                        if(res.code == 200){
                            this.$message.success(res.msg);
                            this.init()
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }else{
                    this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3);
                }
            },
//            添加
            addOrders(){
                this.visible = true
                this.fromSelectData()
                this.form.resetFields();
                this.orderFromVal = {}

                this.targetOrderTypeDelType = false
                this.targetOrderTypePickType = false
                this.imageUrlList = [];
            },
//            双击编辑
            dbClickEdit({row}){
                this.visible = true
                this.fromSelectData()
                this.form.resetFields();
                //this.orderFromVal = row
                ajax.get(api.TMSGETTMSDOHEADERBYID,{doHeaderUid: row.uid}).then(res=>{
                    this.orderFromVal = res.data
                    //根据当前DOID获取相关图片及签名
                    this.loadImagesData(row.doId);
                    if(row.orderType == 'D' || row.orderType == 'DP'){
                        this.activeKey = ['1','2','5','6']
                        this.targetOrderTypeDelType = true
                        if(row.orderType == 'DP'){
                            this.targetOrderTypePickType = true
                            this.activeKey = ['1','2','3','5','6']
                        }else{
                            this.targetOrderTypePickType = false
                        }
                    }else if(row.orderType == 'P' || row.orderType == 'PD'){
                        this.activeKey = ['1','3','5','6']
                        this.targetOrderTypePickType = true
                        if(row.orderType == 'PD'){
                            this.targetOrderTypeDelType = true
                            this.activeKey = ['1','2','3','5','6']
                        }else{
                            this.targetOrderTypeDelType = false
                        }
                    }
                    if(this.orderFromVal.status!='00'){
                        this.orderFormDisabled = true;
                    }else{
                        this.orderFormDisabled = false;
                    }
                })

            },
//            下拉数据
            fromSelectData(){
                ajax.get(api.TMSFINDTMSDROPDOWNINFO).then(res=>{
                    this.selectData = res.data
                })
            },
            //加载图片信息
            loadImagesData(doId){
                this.imageUrlList = [];
                ajax.get("/tms/getFileName",{doId: doId}).then(res=>{
                    if(null!=res.data){
                        for (let i=0;i < res.data.length;i++){
                            this.imageUrlList.push(res.data[i].attachmentPath);
                        }
                    }else{
                        this.imageUrlList = [];
                    }
                })
            },
            previewImage(url){//预览图片
                this.imgUrl = url;
                this.isShowImage = true;//显示图片
            },
            saveOrders(){
                this.form.validateFields((err, values) => {
                    if(!err){
                        let params = values
                        values.orderDate =values.orderDate != null ?  values['orderDate'].format('YYYY-MM-DD HH:mm:ss') : null
                        values.expDeliveryDate =values.expDeliveryDate != null ? values['expDeliveryDate'].format('YYYY-MM-DD HH:mm:ss'): null
                        values.actualDeliveryDate =values.actualDeliveryDate != null ? values['actualDeliveryDate'].format('YYYY-MM-DD HH:mm:ss'): null
                        values.ediSendtime1 =values.ediSendtime1 != null ? values['ediSendtime1'].format('YYYY-MM-DD HH:mm:ss'): null
                        values.ediSendtime2 = values.ediSendtime2 != null ? values['ediSendtime2'].format('YYYY-MM-DD HH:mm:ss'): null
                        values.ediSendtime3 =values.ediSendtime3 != null ? values['ediSendtime3'].format('YYYY-MM-DD HH:mm:ss'): null
                        values.ediSendtime4 =values.ediSendtime4 != null ?  values['ediSendtime4'].format('YYYY-MM-DD HH:mm:ss'): null
                        values.ediSendtime5 =values.ediSendtime5 != null ?  values['ediSendtime5'].format('YYYY-MM-DD HH:mm:ss'): null

                       /* values.expStartTime = values.expStartTime != null ? values['expStartTime'].format('YYYY-MM-DD HH:mm:ss'): null
                        values.expEndTime = values.expEndTime != null ? values['expEndTime'].format('YYYY-MM-DD HH:mm:ss'): null*/

                        if(values.orderType=='DP' && values.deliveryAddress1 != values.pickupAddress1){
                            this.$customMessage.warning("Pickup and Delivery address should be the same in DP Type");
                            return;
                        }

                        if(this.orderFromVal.uid){
                            params.uid = this.orderFromVal.uid
                        }
                        ajax.post(api.TMSSAVETMSDOHEADER,params).then(res=>{
                            if(res.code == 200){
                                this.$message.success(res.msg);
                                this.visible = false
                                this.init()
                            }else{
                                this.$customMessage.warning(res.msg);
                            }
                        })
                    }else{
                        for(let i in err){
                            this.$customMessage.warning(err[i].errors[0].message)
                        }
                    }
                });
            },
            importTmsDoHeaders(){
                this.uploadVisible = true

            },
            fileSelected() {
                const list = this.$refs.importExcelRef.files
                for (let i = 0; i < list.length; i++) {
                    const item = {
                        name: list[i].name,
                        size: list[i].size,
                        file: list[i]
                    }
                    //this.html5Reader(list[i], item)
                    this.files.push(item)
                    this.updataExcelName = list[i].name
                    break;
                }
                this.$refs.importExcelRef.value = ''
            },
            // 将图片文件转成BASE64格式
            html5Reader(file, item){
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.$set(item, 'src', e.target.result)
                }
                reader.readAsDataURL(file)
            },
            //      上转excel
            fileUpload(el) {

                let param = new FormData();

               // let file = event.target.files[0]; // 获取上传excel

              this.files.forEach(file => {
                    param.append("file", file.file);
                 //   param.append("orderNo","aaaaaaaaaaaaaa")
                    console.log(">>file...:"+file.file);
                    console.log(">>file...:"+file.size);
                });

               // axios.post()
                ajax.post(api.TMSIMPORTDOHEADER, param).then(res => {
                    if (res.code == 200) {
                        this.files = [];
                        this.$refs.importExcelRef.value = '';
                        this.updataExcelName = '';
                        this.$message.success(res.msg);
                        this.init();
                        this.cancelModal();
                    }else{
                        this.files = [];
                        this.$refs.importExcelRef.value = '';
                        this.updataExcelName = '';
                        this.$customMessage.error(res.msg);
                        // this.init();
                        // this.cancelModal();
                    }

                });
            },
            cancelModal(){
                this.uploadVisible = false;
            },
            hideImage(){
                this.isShowImage = false;
            },
            query(){
                this.formQuery.validateFields((err, values) => {
                    if(err){
                        this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 3);
                        return;
                    }
                    if(values){

                        let expDeliveryFrom = values.expDeliveryDateFrom;
                        let expDeliveryTo = values.expDeliveryDateTo;
                        if(null!=expDeliveryFrom && null!=expDeliveryTo && expDeliveryFrom>expDeliveryTo){
                            this.$customMessage.warning("From Date cannot greater than To Date");
                            return;
                        }
                        this.tableData = []
                        let params = {
                            condition:values,
                            hideCancelled: false,
                            pageNumber: this.orders.currentVal,
                            pageSize: this.orders.pagingSize
                        }
                        ajax.get(api.TMSGETTMSDOHEADERS,params).then(res=>{
                            console.log(res.data)
                            this.tableData = res.data
                            this.orders.pagingTotal = res.total
                            this.oldTable = JSON.parse(JSON.stringify(res.data))
                        })
                    }
                });
            },
            reset(){
                this.formQuery.resetFields();
            },

            init(){
                this.tableData = []
                let params = {
                    hideCancelled: false,
                    pageNumber: this.orders.currentVal,
                    pageSize: this.orders.pagingSize
                }
                ajax.get(api.TMSGETTMSDOHEADERS,params).then(res=>{
                    console.log(res.data)
                    this.tableData = res.data
                    this.orders.pagingTotal = res.total
                    this.oldTable = JSON.parse(JSON.stringify(res.data))
                })
            },
            rowDrop () {
                let that = this
                this.$nextTick(() => {
                    let ordersTableRef = this.$refs.ordersTableRef
                        this.sortable = Sortable.create(ordersTableRef.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                            handle: '.drag-btn',
                            group: {name:'od'},
                            sort: false,
                            onEnd: function (/**Event*/evt) {
                                let len = that.$refs.ordersTableRef.getCheckboxRecords()
                                let arr = []
                                let expDeliverDates=null;
//                                多条沟中一起托
                                if(len.length  == 0){
                                    arr.push(that.oldTable[evt.oldIndex].uid)
                                    expDeliverDates=that.oldTable[evt.oldIndex].expDeliveryDate
                                }else{
                                    let edd="0";
                                    for(let i in len){
                                        if (len[i].expDeliveryDate==null ||  len[i].expDeliveryDate==undefined){
                                            edd="1"
                                            break
                                        }
                                    }
                                    for(let i in len){
                                        arr.push(len[i].uid);
                                        if(edd!="1"){
                                            expDeliverDates=len[i].expDeliveryDate
                                        }
                                    }
//                                    拖拽当前 但没有勾选
                                    if (arr.indexOf(that.oldTable[evt.oldIndex].uid)  == -1) {
                                        arr.push(that.oldTable[evt.oldIndex].uid)
                                        expDeliverDates=that.oldTable[evt.oldIndex].expDeliveryDate
                                    }
                                }

                                let params = {
                                    routeId: that.routeNo,
                                    wayId: that.waypointNo,
                                    routeWayUid: that.wayUid,
                                    doHeaderUids:arr.toString(),
                                    expDeliveryDate : expDeliverDates,
                                    flag:'orders'
                                }
                              /*  if(params.wayId == null){
                                    that.$customMessage.warning('Please select wayPoints');
                                    that.init();
                                }else{
                                    that.$store.commit("updatatmsDrag", { tmsDrag: params });
                                }*/
                                that.$store.commit("updatatmsDrag", { tmsDrag: params });
                            }

                            // onEnd: ({ newIndex, oldIndex }) => {
                            //     let table = JSON.parse(JSON.stringify(that.tableData))
                            //    // console.log(">>oldIndex:"+oldIndex+",newIndex"+newIndex);
                            //    // console.log(">>oldIndex:"+that.table[oldIndex].doId);
                            //    // console.log(">>newIndex:"+that.table[newIndex].doId);
                            //     if(newIndex == oldIndex){
                            //         return
                            //     }else{
                            //        // let table = JSON.parse(JSON.stringify(that.tableData))
                            //       //  console.log(">>newIndex:"+table[newIndex].doId);
                            //       //  console.log(">>oldIndex:"+that.tableData[oldIndex].doId);
                            //         let arr = []
                            //         arr.push(that.tableData[oldIndex].uid);
                            //     /*    let params = {
                            //             routeId: that.routeNo,
                            //             wayId: that.waypointNo,
                            //             routeWayUid: that.wayUid,
                            //             doHeaderUids:arr.toString()
                            //         }
                            //         ajax.post(api.TMSSAVETMSROUTEDETAIL,params).then(res=>{
                            //             if(res.code == 200){
                            //                 this.init();
                            //             }else{
                            //                 that.$customMessage.warning(res.msg);
                            //             }
                            //         })*/
                            //     }
                            // },

                        })
                })
            }
        }
    }
</script>
<style>
    .sortable-row-demo .drag-btn {
        cursor: move;
        font-size: 12px;
    }
    .main{
        width: 100%;
        height: 100%;
        background-color: white;
        float: left;
    }
    /*.queryButton{*/
    /*    margin-top: 100px;*/
    /*}*/
    .queryParam{
        float: left;
        margin: 5px 10px;
    }
    .queryButton{
        border: 1px solid #e8eaec;
        padding:5px;
    }
    .pagination{
        border: 1px solid #e8eaec;
        width: 100%;
        padding: 5px 0;
        margin-top: 10px;
    }
    .funcButton{
        cursor: pointer;
        margin-left: 5px;
    }
</style>